import {LoginWithEmailForm, LoginWithEmailFormProps} from "./LoginWithEmailForm";
import {FC, useState} from "react";
import {Dialog, Text, Toast} from "@wakelet/ui-kit";
import {translate, translateKey} from "../language/translate";
import {InitResetPassword} from "../reset-password/InitResetPassword";
import {triggerResetPassword} from "../../firebase";
import {toAccountsError} from "../../firebase/errors";

export const LoginFormWithResetPassword: FC<LoginWithEmailFormProps> = (
    {preloadEmail, readOnlyEmail, hideEmail}
) => {
    return (
        <div className="flex flex-col items-center">
            <LoginWithEmailForm preloadEmail={preloadEmail} hideEmail={hideEmail} readOnlyEmail={readOnlyEmail}/>
            <ResetPassword />
        </div>
    );
}

const ResetPassword = () => {
    const [showResetPasswordDialog, setShowResetPasswordDialog] = useState<boolean>(false);
    return (
        <div className="my-4" data-testid="reset-password-container">
            <button onClick={() => setShowResetPasswordDialog(true)} className="appearance-none">
                <Text className="cursor-pointer hover:underline">{translate("login.forgotten", "account")}</Text>
            </button>
            <ResetPasswordPopup showDialogue={showResetPasswordDialog} closeDialogue={() => setShowResetPasswordDialog(false)} />
        </div>
    );
}

const ResetPasswordPopup = ({showDialogue, closeDialogue}: {showDialogue: boolean, closeDialogue: () => void}) => {
    const [isSuccess, setIsSuccess] = useState<boolean>(false);
    const [isError, setIsError] = useState<boolean>(false);

    return <>
        <Toast type="success" description={translateKey("account:resetPassword.success.message")} open={isSuccess} onOpenChange={() => setIsSuccess(false)}/>
        <Toast type="error" description={translateKey("account:resetPassword.error.message")} open={isError} onOpenChange={() => setIsError(false)}/>
        <Dialog title={translateKey("account:resetPassword.title")} open={showDialogue}
                onClose={closeDialogue}>
            <InitResetPassword
                close={closeDialogue}
                onSubmit={(values) => {return doTriggerResetPassword(values.email)}}
                setIsSuccess={(b: boolean) => setIsSuccess(b)}
                setIsError={(b: boolean) => setIsError(b)}
            />
        </Dialog>
    </>
};

const doTriggerResetPassword = (email: string) => {
    return triggerResetPassword(email).
    then(()=>{return}).
    catch(err => Promise.reject(toAccountsError(err, "invalidLinkOrCode")));
};
